export default function ResultsAfterTraining() {
  const results = [
    { icon: 'ri-line-chart-line', title: 'Рост конверсии', desc: 'Увеличение конверсии на 20-40% за счёт системной работы с воронкой продаж' },
    { icon: 'ri-arrow-up-circle-line', title: 'Рост среднего чека', desc: 'Уверенная работа менеджеров с ценой и допродажами увеличивает доход со сделки' },
    { icon: 'ri-user-heart-line', title: 'Снижение потерь клиентов', desc: 'Повышение качества коммуникации снижает отток и увеличивает retention rate' },
    { icon: 'ri-chat-check-line', title: 'Повышение качества переговоров', desc: 'Менеджеры уверенно ведут сложные сделки и выигрывают тендеры' },
    { icon: 'ri-rocket-2-line', title: 'Быстрая адаптация новичков', desc: 'Единые стандарты и система обучения сокращают выход новичка на план в 2-3 раза' },
    { icon: 'ri-file-copy-2-line', title: 'Единые стандарты продаж', desc: 'Понятные скрипты, алгоритмы и чек-листы для всей команды' },
    { icon: 'ri-refresh-line', title: 'Рост повторных продаж', desc: 'Менеджеры выстраивают долгосрочные отношения и системно возвращают клиентов' },
    { icon: 'ri-funds-box-line', title: 'Рост прибыли', desc: 'Суммарный эффект: выше конверсия, выше чек, ниже отток — прибыль растёт' },
  ];

  return (
    <section id="results" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Результаты после обучения
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto">
          Каждый результат измерим и подтверждён практикой. Мы фиксируем KPI до и после обучения, чтобы вы видели реальную отдачу.
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {results.map((result, i) => (
            <div key={i} className="bg-gray-50 p-6 rounded-xl hover:bg-teal-50 transition-colors group text-center">
              <div className="w-12 h-12 bg-teal-600 rounded-xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform">
                <i className={`${result.icon} text-xl text-white`}></i>
              </div>
              <h3 className="font-bold text-gray-900 mb-2 text-sm">{result.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{result.desc}</p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="mt-14 text-center">
          <div className="inline-block bg-teal-50 border border-teal-200 rounded-xl px-8 py-5">
            <p className="text-lg md:text-xl font-bold text-teal-800">
              Системное обучение отдела продаж окупается в первый месяц
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}